// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__3NumJ","container":"styles_container__jhfv1","otpInput":"styles_otpInput__6wKRp","error":"styles_error__UvElZ"};